import { createAction, props, Action } from '@ngrx/store';
import { ApiError, ApplicantImageUploadResponse } from '../client/src';
import { ImageUpload } from '../types/image-upload.interface';

export const UPLOAD_IMAGE_TYPE = '[Checkout] Upload Image API';
export const checkoutAPI_uploadImage = createAction(
  UPLOAD_IMAGE_TYPE,
  props<{ image: ImageUpload; save?: boolean }>()
);

export const checkoutAPI_uploadImageSuccess = createAction(
  `${UPLOAD_IMAGE_TYPE} Success`,
  props<{
    basketId: string;
    itemId: string;
    quantityIndex: number;
    response: ApplicantImageUploadResponse;
  }>()
);

export const checkoutAPI_uploadImageFailure = createAction(
  `${UPLOAD_IMAGE_TYPE} Failure`,
  props<{
    error?: string | ApiError;
    basketId: string;
    itemId: string;
    quantityIndex: number;
    retryAction?: Action;
  }>()
);

export const LOAD_IMAGE_TYPE = '[Checkout] Load Image API';
export const checkoutAPI_loadImage = createAction(
  LOAD_IMAGE_TYPE,
  props<{ basketId: string; itemId: string; quantityIndex: number; save?: boolean }>()
);

export const checkoutAPI_loadImageSuccess = createAction(
  `${LOAD_IMAGE_TYPE} Success`,
  props<{
    basketId: string;
    itemId: string;
    quantityIndex: number;
    blob?: Blob;
  }>()
);

export const checkoutAPI_loadImageFailure = createAction(
  `${LOAD_IMAGE_TYPE} Failure`,
  props<{
    error?: string | ApiError;
    basketId: string;
    itemId: string;
    quantityIndex: number;
    retryAction?: Action;
  }>()
);
